import { CascaderStore } from './types';
import mutations from './mutations';

const state: CascaderStore = {
  otherValue: '',
  selectArr: [],
  isSubmit: false,
  durationStart: 0,
  maxLevel: 0
};

export default {
  namespaced: true,
  state,
  mutations
};
